import React, { ReactNode, useEffect } from 'react';
import cx from 'classnames';
import { Layout, Spin } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { RouteComponentProps, useParams, withRouter } from 'react-router';

import { Features } from '../../featureToggles/features';
import { DashboardHeader } from '../common/dashboardHeader';

import { ListParams } from '../../slices/utils';
import { FilterOperators, Ifilter } from '../common/filters/interfaces';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAccountsList } from '../../slices/accounts/list.thunks';
import { selectors as accountListSelectors } from '../../slices/accounts/list';
import { RootState } from '../../slices/rootReducer';
import { LoadingOutlined } from '@ant-design/icons';
import { isExternalClient } from '../../utils/clients';

import styles from './accountsTable.module.scss';

interface MatchParams {
  id: string;
}

interface LayoutProps extends RouteComponentProps<MatchParams> {
  children: ReactNode;
  actions?: ReactNode[];
  contentClass?: string;
  isLoading?: boolean;
}

//AccountsDashboardForPlgExternal
const AccountsDashboardBase: React.FC<LayoutProps> = ({ children, actions, contentClass, match, isLoading }) => {
  const { id = '' } = useParams<MatchParams>();
  const account = useSelector((state: RootState) => accountListSelectors.getAccountById(state, id));
  const isDirtyAccount = useSelector((state: RootState) => accountListSelectors.getIsDirty(state));
  const dispatch = useDispatch();
  useEffect(() => {
    const shouldReload = isDirtyAccount === true; // TODO, remove this comparison when plgexternal3 feature toggle is removed
    if (!account || shouldReload) {
      const fetchAccountsRequest: ListParams<Ifilter[]> = {
        filters: [
          {
            field: '_id',
            operands: [id],
            operator: FilterOperators.isAnyOf,
            validateInputs: false
          }
        ],
        pagination: { offset: 0, limit: 25 }
      };
      dispatch(fetchAccountsList(fetchAccountsRequest));
    }
  }, [id, account, dispatch, isDirtyAccount]);

  const renderContent = () => {
    const antIcon = <LoadingOutlined className={styles.loadingOutlined} spin />;
    const isOnUsersTab = match.url.includes('users');
    const hasCurrentDeal = account?.currentDeal !== undefined || isExternalClient();
    if (isLoading || (!isOnUsersTab && !hasCurrentDeal)) {
      return <div className={styles.loadingContainer}><Spin indicator={antIcon} className={styles.loading} /></div>;
    }
    return <main className={styles.mainContent}>{children}</main>;
  };

  return (
    <div className={styles.dashboardForPlgExternal}>
      <DashboardHeader accountId={id} actions={actions} />
      <Layout className={cx(styles.filterDrawerContainer, styles[Features.Uirefresh], contentClass)}>
        <Content className={styles.dashboardContent}>
          {renderContent()}
        </Content>
      </Layout>
    </div>
  );
};

export const AccountsDashboard = withRouter(AccountsDashboardBase);

